import { Link } from 'react-router-dom';
import { FaClock, FaEnvelope, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import CtaButton from './CtaButton';
import { useLeadForm } from '../context/LeadFormContext';
import { CONTACT, phoneHref } from '../constants/contact';
import { COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../constants/site';
import './Footer.css';

const footerLinks = {
  services: [
    { to: '/#services', label: 'Automotive GPS' },
    { to: '/#services', label: 'In-Dash Navigation' },
    { to: '/#services', label: 'Marine GPS' },
  ],
  resources: [
    { to: '/#guides', label: 'Update Guides' },
    { to: '/#support', label: 'Troubleshooting' },
    { to: '#quote', label: 'Request Help', opensForm: true },
  ],
  legal: [
    { to: '/privacy-policy', label: 'Privacy Policy' },
    { to: '/terms-of-service', label: 'Terms of Service' },
    { to: '/refund-policy', label: 'Refund Policy' },
  ],
};

export default function Footer() {
  const { openLeadForm } = useLeadForm();

  return (
    <footer className="gps-footer">
      <div className="container gps-footer-grid">
        <div className="gps-footer-brand">
          <h3>{SITE_NAME}</h3>
          <p>
            Expert guidance for automotive, in-dash, and marine GPS map updates at{' '}
            <strong>{SITE_DOMAIN}</strong> — backed by <strong>{COMPANY_NAME}</strong>.
          </p>
          <CtaButton className="btn btn-primary gps-footer-cta btn--inline">
            Update Maps Now
          </CtaButton>
        </div>

        <div>
          <h4>Services</h4>
          <ul>
            {footerLinks.services.map((link) => (
              <li key={link.label}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Resources</h4>
          <ul>
            {footerLinks.resources.map((link) => (
              <li key={link.label}>
                {link.opensForm ? (
                  <button type="button" className="gps-footer-link-btn" onClick={openLeadForm}>
                    {link.label}
                  </button>
                ) : (
                  <Link to={link.to}>{link.label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Legal</h4>
          <ul>
            {footerLinks.legal.map((link) => (
              <li key={link.label}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="gps-footer-contact">
          <h4>Contact</h4>
          <div className="gps-footer-contact-list">
            <div className="gps-footer-contact-item">
              <FaPhone className="gps-footer-contact-icon" aria-hidden="true" />
              <div>
                <strong>Phone</strong>
                <a href={phoneHref}>{CONTACT.phone}</a>
              </div>
            </div>
            <div className="gps-footer-contact-item">
              <FaEnvelope className="gps-footer-contact-icon" aria-hidden="true" />
              <div>
                <strong>Email</strong>
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </div>
            </div>
            <div className="gps-footer-contact-item">
              <FaMapMarkerAlt className="gps-footer-contact-icon" aria-hidden="true" />
              <div>
                <strong>Address</strong>
                <span>{CONTACT.address}</span>
              </div>
            </div>
            <div className="gps-footer-contact-item">
              <FaClock className="gps-footer-contact-icon" aria-hidden="true" />
              <div>
                <strong>Hours</strong>
                <span>{CONTACT.hoursWeekdays}</span>
                <span>{CONTACT.hoursSaturday}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gps-footer-bottom">
        <div className="container">
          <p>
            © {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved. | {SITE_NAME} — {SITE_DOMAIN}
          </p>
        </div>
      </div>
    </footer>
  );
}
